import React, { useState, useEffect } from 'react';
import axios from 'axios';

const LeadsTab = ({ showToast }) => {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [converting, setConverting] = useState(null);

  const fetchLeads = async () => {
    try {
      const res = await axios.get('/api/meta/leads', {
        headers: { Authorization: `Bearer ${localStorage.getItem('crm_token')}` }
      });
      setLeads(res.data || []);
    } catch (err) {
      console.error(err);
      showToast('Leadler yüklenirken hata oluştu', 'error');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLeads();
  }, []);

  const handleConvert = async (lead) => {
    if (converting) return;
    setConverting(lead.id);
    try {
      await axios.post(`/api/meta/leads/${lead.id}/convert`, {}, {
        headers: { Authorization: `Bearer ${localStorage.getItem('crm_token')}` }
      });
      showToast('Lead başarıyla müşteriye dönüştürüldü', 'success');
      fetchLeads();
    } catch (err) {
      console.error(err);
      showToast(err.response?.data?.error || 'Dönüştürme hatası', 'error');
    } finally {
      setConverting(null);
    }
  };

  if (loading) return <div style={{ textAlign: 'center', padding: '40px', color: 'var(--text-muted)' }}>Yükleniyor...</div>;

  return (
    <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
      <div style={{ padding: '20px', borderBottom: '1px solid var(--border)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h3 style={{ margin: 0, fontSize: '16px', color: 'var(--text)' }}>Lead Form Başvuruları</h3>
        <span style={{ fontSize: '13px', color: 'var(--text-muted)' }}>Toplam {leads.length} lead</span>
      </div>

      <div className="table-container" style={{ border: 'none', borderRadius: 0 }}>
        <table className="table">
          <thead>
            <tr>
              <th>Ad Soyad</th>
              <th>İletişim</th>
              <th>Kampanya</th>
              <th>Tarih</th>
              <th>Durum</th>
              <th>İşlem</th>
            </tr>
          </thead>
          <tbody>
            {leads.length === 0 ? (
              <tr>
                <td colSpan="6" style={{ padding: '40px', textAlign: 'center', color: 'var(--text-muted)' }}>Henüz lead verisi yok. (Webhook kurulumunu tamamlayın)</td>
              </tr>
            ) : (
              leads.map(lead => (
                <tr key={lead.id}>
                  <td style={{ fontWeight: '500', color: 'var(--text)' }}>
                    {lead.first_name} {lead.last_name}
                  </td>
                  <td>
                    <div>{lead.email}</div>
                    <div style={{ color: 'var(--text-muted)', fontSize: '12px' }}>{lead.phone}</div>
                  </td>
                  <td style={{ color: 'var(--text-muted)' }}>{lead.campaign_name || 'Bilinmiyor'}</td>
                  <td style={{ color: 'var(--text-muted)' }}>{new Date(lead.created_time).toLocaleString('tr-TR')}</td>
                  <td>
                    {lead.status === 'converted' ? (
                      <span className="badge badge-success">Dönüştürüldü</span>
                    ) : (
                      <span className="badge badge-warning">Yeni Lead</span>
                    )}
                  </td>
                  <td>
                    {lead.status !== 'converted' && (
                      <button
                        onClick={() => handleConvert(lead)}
                        disabled={converting === lead.id}
                        className="btn btn-primary btn-sm"
                      >
                        {converting === lead.id ? 'İşleniyor...' : 'Müşteri Yap'}
                      </button>
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default LeadsTab;
